import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [FETCH_FLOORS, FETCH_FLOORS_SUCCESS, FETCH_FLOORS_FAIL] = createRequestConstantNames(
  cc('FETCH_FLOORS')
);
